<template>
    <div id="archive" :key="renderCount">
        <AppBreadCrumb :paths="[{ title: $t('message.archive') }]" :select="true" :show-subjects="true">
            <!-- Time Select Dropdown - Sadece bu AppBreadCrumb içinde -->
            <div class="time-select-section">
                <select id="time-select" v-model="timeSelect" class="time-select-dropdown">
                    <option value="today">{{ $t("time.today") }}</option>
                    <option value="yesterday">{{ $t("time.yesterday") }}</option>
                    <option value="current-week">{{ $t("time.currentWeek") }}</option>
                    <option value="last-week">{{ $t("time.lastWeek") }}</option>
                    <option value="current-month">{{ $t("time.currentMonth") }}</option>
                    <option value="last-month">{{ $t("time.lastMonth") }}</option>
                    <option value="last-30">{{ $t("time.last30Day") }}</option>
                    <option value="custom">{{ $t("time.custom") }}</option>
                    <option v-for="(m, i) in getLast11Months()" :key="i" :value="m.date">
                        {{ m.name }}
                    </option>
                </select>
            </div>
        </AppBreadCrumb>

        <div class="archive-toolbar">
            

            <!-- Filter Bar -->
            <ArchiveFilterBar
                :query="query"
                :start-date="startDate"
                :end-date="endDate"
                :selected-user="selectedUser"
                :selected-site="selectedSite"
                :multi-select-value="multiSelectValue"
                :destroyer-multi-select-value="destroyerMultiSelectValue"
                :starter-multi-select-value="starterMultiSelectValue"
                :tags-multi-select-value="tagsMultiSelectValue"
                :point="point"
                :filter-description="filterDescription"
                :filter-video-call="filterVideoCall"
                :filter-lost-chats="filterLostChats"
                :filter-closed-by-agent="filterClosedByAgent"
                :time-select="timeSelect"
                :users-filter="usersFilter.data || []"
                @change="handleFiltersChange"
                @reset-filters="resetFilters"
            />

            <!-- Search Section -->
            <div class="search-section">
                <div class="search-bar">
                    <input type="text" :placeholder="$t('message.query')" v-model="query" class="search-input" />
                    <a-tooltip
                        placement="top"
                        title="İsim, mail, not, tel no, kullanıcı bilgileri alanlarında arama yapar"
                    >
                        <span class="exclamation">!</span>
                    </a-tooltip>
                </div>
            </div>
        </div>

        <b-container class="mt-3" fluid>
            <b-row v-if="selectedVisitorId" class="filterLabelWrapper">
                <VisitorMiniFilterPreview
                    :default-open="false"
                    :value="{ name: 'visitorId', value: selectedVisitorId, rule: 'is' }"
                    :on-finished="$_.noop"
                    :on-removed="removeSelectedVisitorIDFilter"
                    icon="filter_alt"
                    :read-only="true"
                />
            </b-row>
            <b-row class="custom-row">
                <!-- Burası Unutma -->
                <b-col :class="{ 'col-lg-5': !wideScreen, 'col-lg-4': wideScreen }">
                    <div scroll-top="0" id="conversation-list" class="scrollable">
                        <EmptyFilterResult
                            v-if="!visitors.data.length && !isBusy && !spinnerShow"
                            :clear-filters="resetFilters"
                        />
                        <div>
                            <div class="pagination-toolbar">
                                <a-button
                                    style="margin-right: auto !important"
                                    class="actionButton d-flex align-items-center classic-button"
                                    size="small"
                                    @click="resetFilters"
                                    v-tippy="{ placement: 'bottom' }"
                                    :content="$t('message.clearSelectedFiltersTooltip')"
                                >
                                    <span style="margin-right: 3px; display: block; font-size: 12px; overflow: hidden">
                                        <span class="md-icon">delete_forever</span>
                                    </span>
                                </a-button>
                                <span class="actions">
                                    <a @click="decreaseAll" style="margin-right: 10px"><<</a>
                                    <a @click="decrease"><</a>
                                    <!--                                    <span style="width: auto; margin: 0 6px">{{ currentPage }}</span>-->
                                    <a-input type="number" v-model="currentPage" style="width: 60px; border: none" />
                                    <div style="padding: 2px; font-size: 15px">/</div>
                                    <span style="width: auto; margin: 0 6px">{{ visitors.pageCount }}</span>
                                    <a @click="increase">></a>
                                    <a @click="increaseAll" style="margin-left: 10px">>></a>
                                </span>
                                <a-popover
                                    placement="bottom"
                                    overlayClassName="btnPerPagePopover"
                                    :visible="pageSizeChangerVisible"
                                    @visibleChange="pageSizeChangerVisible = !pageSizeChangerVisible"
                                >
                                    <template slot="content">
                                        <div class="page-options">
                                            <div
                                                v-for="(val, i) of [5, 10, 20, 30, 50, 75, 100, 150, 200, 250, 300]"
                                                @click="changePerPage(val)"
                                                :key="i"
                                                class="item"
                                            >
                                                <span class="value">{{ val }}</span>
                                            </div>
                                        </div>
                                    </template>
                                    <a-button class="btnPerPage" @click="pageSizeChangerVisible = true">
                                        <SortIcon />
                                        {{ $t("message.perPageInFilter") }}: {{ pagination.limit }}
                                        <a-icon type="caret-down" />
                                    </a-button>
                                </a-popover>
                            </div>
                        </div>

                        <div v-if="!isBusy && !spinnerShow">
                            <div v-if="visitors.data.length > 0">
                                <b-table
                                    v-if="!isScrolling"
                                    id="visitor-list-table"
                                    :items="visitors.data.slice(0, perPage)"
                                    :fields="fields"
                                    :tbody-tr-class="rowClass"
                                >
                                    <div slot="table-busy" class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                    </div>
                                    <template v-slot:cell(actions)="data, item">
                                        <div :key="data.item._id" class="info" @click="view(data.item._id)">
                                            <div class="custom-card userInfo">
                                                <b>{{ maskContactFullname(data.item.fullname || "-", data.item) }}</b>
                                                <b>
                                                    {{ getEmail(data.item) }}
                                                </b>
                                                <b>{{
                                                    (data.item.users.length > 0
                                                        ? data.item.users.slice(0, 3)
                                                        : [data.item.connectedUser]
                                                    ).filter(Boolean)
                                                        .map((x) => getUserHelper(x))
                                                        .join(", ")
                                                }}</b>
                                            </div>
                                            <div class="custom-card back chatMeta">
                                                <b>{{ data.item.createdDate | date("D/M/YY HH:m:s") }}</b>
                                                <b>
                                                    <PassedTimeCounterTimeFormat
                                                        :id="data.item._id"
                                                        :date="data.item.connectedDate || data.item.createdDate"
                                                        :endDate="data.item.destroyedDate"
                                                        :shortFormat="true"
                                                    />
                                                </b>
                                                <b>
                                                    <a-rate
                                                        :default-value="data.item.point || 0"
                                                        :style="{
                                                            color: data.item.description ? 'orangered' : '#fadb14',
                                                        }"
                                                        disabled
                                                        size="12"
                                                    />
                                                </b>
                                            </div>
                                        </div>
                                    </template>
                                </b-table>
                                <div v-else class="text-center text-info my-3">
                                    <b-table
                                        id="visitor-list-tables"
                                        :fields="fields"
                                        :items="visitors.data"
                                        :tbody-tr-class="rowClass"
                                    >
                                        <div slot="table-busy" class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                        </div>
                                        <template v-slot:cell(actions)="data, item">
                                            <div :key="data.item._id" class="info" @click="view(data.item._id)">
                                                <div class="custom-card userInfo">
                                                    <b>{{ data.item.fullname || "-" }}</b>
                                                    <b>
                                                        {{ getEmail(data.item) }}
                                                    </b>
                                                    <b>{{
                                                        (data.item.users.length > 0
                                                            ? data.item.users.slice(0, 3)
                                                            : [data.item.connectedUser]
                                                        ).filter(Boolean)
                                                            .map((x) => getUserHelper(x))
                                                            .join(", ")
                                                    }}</b>
                                                </div>
                                                <div class="custom-card back chatMeta">
                                                    <b>{{ data.item.createdDate | date("D/M/YY HH:m:s") }}</b>
                                                    <b>
                                                        <PassedTimeCounterTimeFormat
                                                            :id="data.item._id"
                                                            :date="data.item.connectedDate || data.item.createdDate"
                                                            :endDate="data.item.destroyedDate"
                                                            :shortFormat="true"
                                                        />
                                                    </b>
                                                    <b>
                                                        <a-rate
                                                            :default-value="data.item.point || 0"
                                                            :style="{
                                                                color: data.item.description ? 'orangered' : '#fadb14',
                                                            }"
                                                            disabled
                                                            size="12"
                                                        />
                                                    </b>
                                                </div>
                                            </div>
                                        </template>
                                    </b-table>
                                    <ul class="archive-skeleton">
                                        <li class="pb-3" v-for="(v, i) in 3" :key="i" style="list-style: none">
                                            <div class="info row">
                                                <div class="col custom-card userInfo">
                                                    <a-skeleton active :paragraph="{ rows: 2 }" />
                                                </div>
                                                <div class="col custom-card back chatMeta">
                                                    <a-skeleton
                                                        class="row"
                                                        active
                                                        :paragraph="{ rows: 1 }"
                                                        style="padding-left: 15px !important"
                                                    />
                                                    <b style="display: block; text-align: start; margin-top: 13px">
                                                        <a-rate
                                                            class="row"
                                                            :default-value="5"
                                                            style="color: #fadb14"
                                                            disabled
                                                            size="12"
                                                        />
                                                    </b>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div v-else class="text-center text-info my-3">
                                {{ $t("message.chatNotFound") }}
                            </div>
                        </div>
                        <div v-if="!!isBusy && !spinnerShow" class="text-center text-info my-3">
                            <div v-if="!!lastRegisteredMessages.length">
                                <b-table
                                    v-if="!isScrolling"
                                    id="visitor-list-table"
                                    :fields="fields"
                                    :items="lastRegisteredMessages"
                                    :tbody-tr-class="rowClass"
                                >
                                    <div slot="table-busy" class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                    </div>
                                    <template v-slot:cell(actions)="data, item">
                                        <div :key="data.item._id" class="info" @click="view(data.item._id)">
                                            <div class="custom-card userInfo">
                                                <b>{{ data.item.fullname || "-" }}</b>
                                                <b>
                                                    {{ getEmail(data.item) }}
                                                </b>
                                                <b>{{
                                                    (data.item.users.length > 0
                                                        ? data.item.users.slice(0, 3)
                                                        : [data.item.connectedUser]
                                                    ).filter(Boolean)
                                                        .map((x) => getUserHelper(x))
                                                        .join(", ")
                                                }}</b>
                                            </div>
                                            <div class="custom-card back chatMeta">
                                                <b>{{ data.item.createdDate | date("D/M/YY HH:m:s") }}</b>
                                                <b>
                                                    <PassedTimeCounterTimeFormat
                                                        :id="data.item._id"
                                                        :date="data.item.connectedDate || data.item.createdDate"
                                                        :endDate="data.item.destroyedDate"
                                                        :shortFormat="true"
                                                    />
                                                </b>
                                                <b>
                                                    <a-rate
                                                        :default-value="data.item.point || 0"
                                                        :style="{
                                                            color: data.item.description ? 'orangered' : '#fadb14',
                                                        }"
                                                        disabled
                                                        size="12"
                                                    />
                                                </b>
                                            </div>
                                        </div>
                                    </template>
                                </b-table>
                            </div>
                            <ul class="archive-skeleton">
                                <li class="pb-3" v-for="(v, i) in skeletonCount" :key="i" style="list-style: none">
                                    <div class="info row">
                                        <div class="col custom-card userInfo">
                                            <a-skeleton active :paragraph="{ rows: 2 }" />
                                        </div>
                                        <div class="col custom-card back chatMeta">
                                            <a-skeleton
                                                class="row"
                                                active
                                                :paragraph="{ rows: 1 }"
                                                style="padding-left: 15px !important"
                                            />
                                            <b style="display: block; text-align: start; margin-top: 13px">
                                                <a-rate
                                                    class="row"
                                                    :default-value="5"
                                                    style="color: #fadb14"
                                                    disabled
                                                    size="12"
                                                />
                                            </b>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <template v-if="spinnerShow" class="spinner">
                            <font-awesome-icon icon="spinner" spin />
                        </template>
                    </div>
                </b-col>

                <b-col :class="{ 'col-lg-7': !wideScreen, 'col-lg-5': wideScreen }" class="pl-3">
                    <div class="scrollable">
                        <div v-if="selectedHistory.id && !wideScreen" class="userMetaInfo bg-white">
                            <b-col style="margin: 10px">
                                <div class="userInfo">
                                    <div class="userInfo first">
                                        {{ $t("message.fullName") }}
                                    </div>
                                    <div
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        :content="
                                            maskContactFullname(
                                                selectedHistory.conversation.fullname,
                                                selectedHistory.conversation
                                            )
                                        "
                                        class="userInfo sec"
                                    >
                                        {{
                                            maskContactFullname(
                                                selectedHistory.conversation.fullname,
                                                selectedHistory.conversation
                                            )
                                        }}
                                    </div>
                                </div>

                                <div class="userInfo">
                                    <div class="userInfo first">
                                        {{ $t("message.email") }}
                                    </div>
                                    <div
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        :content="maskContactInfo('email', selectedHistory.conversation.email, 5)"
                                        class="userInfo sec"
                                    >
                                        {{ maskContactInfo("email", selectedHistory.conversation.email, 5) }}
                                    </div>
                                </div>
                                <div class="userInfo">
                                    <div class="userInfo first">
                                        {{ $t("message.department") }}
                                    </div>
                                </div>

                                <div class="userInfo">
                                    <div class="userInfo first">
                                        {{ $t("message.representative") }}
                                    </div>
                                    <div class="userInfo sec">
                                        {{
                                            (selectedHistory.conversation.users.length > 0
                                                ? selectedHistory.conversation.users.slice(0, 3)
                                                : [selectedHistory.conversation.connectedUser].filter(Boolean)
                                            )
                                                .map((x) => getUserHelper(x))
                                                .join(", ")
                                        }}
                                    </div>
                                </div>

                                <div class="d-flex">
                                    <div class="userInfo">
                                        <div class="userInfo first">
                                            {{ $t("message.country") }}
                                        </div>
                                        <div class="userInfo sec">
                                            {{ $_.get(selectedHistory, "conversation.visitor.country", "-") }}
                                        </div>
                                    </div>

                                    <div class="userInfo pl-3">
                                        <div class="userInfo first">
                                            {{ $t("message.language") }}
                                        </div>
                                        <div class="userInfo sec">
                                            {{ selectedHistory.conversation.languageCode }}
                                        </div>
                                    </div>
                                </div>
                                <div class="userInfo">
                                    <div class="userInfo first">
                                        {{ $t("message.osAndBrowser") }}
                                    </div>
                                    <div class="userInfo sec">
                                        {{ $_.get(selectedHistory, "conversation.visitor.os") }}
                                        {{ $_.get(selectedHistory, "conversation.visitor.browser") }}
                                    </div>
                                </div>

                                <div class="userInfo">
                                    <div class="userInfo first">IP</div>
                                    <div class="userInfo sec">
                                        {{ $_.get(selectedHistory, "conversation.visitor.ipAddress") }}
                                    </div>
                                </div>
                                <div class="userInfo">
                                    <div class="userInfo first">
                                        {{ $t("message.chatId") }}
                                    </div>
                                    <div class="userInfo sec">
                                        {{ selectedHistory.conversation._id }}
                                    </div>
                                </div>
                                <div class="userInfo">
                                    <div class="userInfo first">
                                        {{ $t("message.visitorId") }}
                                    </div>
                                    <div class="userInfo sec">
                                        {{ $_.get(selectedHistory, "conversation.visitor._id") }}
                                        <md-button
                                            v-tippy="{
                                                followCursor: true,
                                                placement: 'bottom-end',
                                                theme: isDarkMode ? 'light-border' : 'google',
                                            }"
                                            class="md-icon-button"
                                            content="Open In Chatbot"
                                            @click="openInChatbot"
                                            v-if="selectedHistory.conversation.startedWithChatBot"
                                        >
                                            <md-icon>open_in_new</md-icon>
                                        </md-button>
                                    </div>
                                </div>
                                <div class="userInfo">
                                    <div class="userInfo first">
                                        {{ $t("message.customerClientVersion") }}
                                    </div>
                                    <div class="userInfo sec">
                                        {{ $_.get(selectedHistory, "conversation.visitor.version.versionStr", "-") }}
                                    </div>
                                </div>
                                <div v-if="selectedHistory.conversation.description" class="userInfo">
                                    <div class="userInfo first">
                                        {{ $t("message.visitorFeedback") }}
                                    </div>
                                    <div class="userInfo sec" @click="showModal">
                                        <p
                                            v-b-modal.visitor-message
                                            style="
                                                word-wrap: break-word;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                                display: -webkit-box;
                                                -webkit-box-orient: vertical;
                                                -webkit-line-clamp: 3;
                                                word-break: break-all;
                                            "
                                        >
                                            {{ selectedHistory.conversation.description }}
                                        </p>
                                    </div>
                                </div>
                            </b-col>
                            <b-row>
                                <b-col>
                                    <h5 class="text-center pointer text-info my-2">
                                        {{ $t("message.userInfo") }}
                                        <md-icon class="text-info">expand_more</md-icon>
                                    </h5>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-if="isBusy || isLoading" id="message-skeleton">
                            <div class="row" style="display: flex; flex-direction: column; align-items: center">
                                <div class="col-sm-4">
                                    <a-skeleton active :paragraph="{ rows: 0 }" />
                                </div>
                            </div>
                            <div class="row" style="display: flex; justify-content: space-between">
                                <div class="col-sm-4" style="margin-top: -12%">
                                    <a-skeleton active :paragraph="{ rows: 1 }" />
                                </div>
                                <div class="col-sm-4" style="margin-top: -8%">
                                    <a-skeleton active :paragraph="{ rows: 2 }" />
                                </div>
                            </div>
                            <div class="row" style="display: flex; flex-direction: column; align-items: center">
                                <div class="col-sm-6" style="margin-top: -15%">
                                    <a-skeleton active :paragraph="{ rows: 0 }" />
                                </div>
                            </div>
                            <div class="row" style="display: flex; justify-content: space-between">
                                <div class="col-sm-4" style="margin-top: -12%">
                                    <a-skeleton active :paragraph="{ rows: 2 }" />
                                </div>
                                <div class="col-sm-4" style="margin-top: -8%">
                                    <a-skeleton active :paragraph="{ rows: 0 }" />
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <MessageList
                                v-if="getMessages().length && selectedHistory.conversation._id !== null"
                                :always-scroll-to-bottom="false"
                                :colors="colors"
                                :messages="getMessages()"
                                :participants="getParticipants()"
                                :scroll-top="true"
                                :channel-id="selectedHistory.conversation.channel"
                                :contextMenuVisable="false"
                            />
                            <div v-else class="bg-light border px-3 py-1 px-3 text-center">
                                {{ $t("message.noMessageInChat") }}
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col class="col-lg-3 bg-white scrollable" v-if="isBusy || isLoading">
                    <ul class="head-title">
                        <a-skeleton active :paragraph="{ rows: 0 }" />
                        <li
                            class="user-info-container mx-3 px-3"
                            v-for="(v, i) in 11"
                            :key="i"
                            style="list-style: none"
                        >
                            <a-skeleton active :paragraph="{ rows: 0 }" />
                        </li>
                    </ul>
                </b-col>
                <b-col
                    class="archiveUserInfoWidget"
                    :class="[selectedHistory.id ? '' : 'bg-white scrollable']"
                    :id="[selectedHistory.id ? '' : 'information-list2']"
                    :style="!selectedHistory.id && { padding: '4px' }"
                    v-else
                >
                    <div v-if="selectedHistory.id">
                        <div id="chatCard">
                            <div class="headtitle">
                                <span class="text">{{ $t("userInfoWidget.userInformation") }}</span>
                                <span class="ml-4 btn-start-chat">
                                    <button
                                        class="classic-button"
                                        @click="
                                            () =>
                                                this.$router.push(
                                                    `/visitors/${selectedHistory.conversation.visitor._id}`
                                                )
                                        "
                                    >
                                        {{ $t("message.userProfile") }}
                                    </button>
                                    <button class="userProfile" @click="startWhatsappChat" v-if="isWABusiness()">
                                        Start Chat
                                    </button>
                                    <button class="userProfile" @click="startWhatsappChat" v-if="isWhatsappV1()">
                                        Start Chat
                                    </button>
                                    <button class="userProfile" @click="startWhatsappChat" v-if="isWhatsappV2()">
                                        Start Chat
                                    </button>
                                    <button class="userProfile" @click="startWhatsappChat" v-if="isWhatsappV3()">
                                        Start Chat
                                    </button>
                                    <button class="userProfile" @click="startInstagramChat" v-if="isInstagram()">
                                        Start Chat
                                    </button>
                                    <button class="userProfile" @click="startMessengerChat" v-if="isMessenger()">
                                        Start Chat
                                    </button>
                                    <button class="userProfile" @click="startTelegramChat" v-if="isTelegram()">
                                        Start Chat
                                    </button>
                                    <button class="userProfile" @click="startLinkedinChat" v-if="isLinkedin()">
                                        Start Chat
                                    </button>
                                    <!--                                    <button class="userProfile" @click="startWebChat" v-if="isWebContact()">-->
                                    <!--                                        Start Chat-->
                                    <!--                                    </button>-->
                                </span>
                            </div>
                            <div class="details-chat-card">
                                <div v-if="getSubjectName(selectedHistory.conversation.subject)" class="user-detail">
                                    <span class="icon material-icons">sell</span>
                                    <div class="flex w-full centered space-between">
                                        <span>
                                            {{ getSubjectName(selectedHistory.conversation.subject) }}
                                        </span>
                                        <button
                                            @click="
                                                copyTextToClipboard(
                                                    getSubjectName(selectedHistory.conversation.subject) || 'N/A'
                                                )
                                            "
                                            class="copyButton"
                                        >
                                            <a-icon type="copy" />
                                        </button>
                                    </div>
                                </div>
                                <div class="user-detail">
                                    <span
                                        class="icon material-icons"
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                        }"
                                        :content="$t('userInfoWidget.fullName')"
                                        >person</span
                                    >
                                    <div class="input-value">
                                        <div class="w-full">
                                            <span id="fullName">{{
                                                maskContactFullname(
                                                    selectedHistory.conversation.fullname,
                                                    selectedHistory.conversation
                                                ) || "N/A"
                                            }}</span>
                                            <span
                                                class="md-icon"
                                                style="color: #ffa800; cursor: pointer"
                                                @click="seeAll"
                                                >zoom_in</span
                                            >
                                        </div>
                                        <div>
                                            <button
                                                @click="
                                                    copyTextToClipboard(
                                                        maskContactFullname(
                                                            selectedHistory.conversation.fullname,
                                                            selectedHistory.conversation
                                                        ) || 'N/A'
                                                    )
                                                "
                                                class="copyButton"
                                            >
                                                <a-icon type="copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="user-detail">
                                    <span
                                        class="icon material-icons"
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                        }"
                                        :content="$t('coupon.email')"
                                        >mail</span
                                    >
                                    <div class="input-value">
                                        <div class="w-full">
                                            {{
                                                maskContactInfo("email", selectedHistory.conversation.email, 5) || "N/A"
                                            }}
                                        </div>
                                        <div>
                                            <button
                                                @click="
                                                    copyTextToClipboard(
                                                        maskContactInfo('email', selectedHistory.conversation.email) ||
                                                            'N/A'
                                                    )
                                                "
                                                class="copyButton"
                                            >
                                                <a-icon type="copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="user-detail"
                                    v-if="
                                        Array.isArray(selectedHistory.conversation.customLoginInfos) &&
                                        selectedHistory.conversation.customLoginInfos.length
                                    "
                                    v-for="inputValue of getCustomLoginInfos()"
                                    :key="inputValue.name"
                                >
                                    <span
                                        class="icon material-icons"
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                        }"
                                        :content="inputValue.name"
                                        >alternate_email</span
                                    >
                                    <div class="input-value">
                                        <div class="w-full">
                                            {{ inputValue.value || "N/A" }}
                                        </div>
                                        <div>
                                            <button
                                                @click="copyTextToClipboard(inputValue.value || 'N/A')"
                                                class="copyButton"
                                            >
                                                <a-icon type="copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="user-detail"
                                    v-if="selectedHistory.conversation.visitor"
                                    v-for="attr of (
                                        (selectedHistory.conversation.visitor &&
                                            selectedHistory.conversation.visitor.contactProperties) ||
                                        []
                                    ).filter((x) => x.property)"
                                    :key="attr._id"
                                >
                                    <span
                                        class="icon material-icons"
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                        }"
                                        :content="attr.property.label"
                                        >data_object</span
                                    >

                                    <span
                                        style="font-weight: bold; font-size: 14px; width: 100px"
                                        :content="attr.property.label"
                                        >{{ attr.property.label }}:</span
                                    >
                                    <div class="input-value">
                                        <div v-if="attr.property.type === 'json'">
                                            <button class="classic-button visitor-attr" @click="JSONModal = true">
                                                JSON PREVIEW
                                            </button>
                                            <Modal2
                                                v-if="JSONModal"
                                                :title="attr.property.label"
                                                @cancel="JSONModal = false"
                                                :show-footer="false"
                                            >
                                                <prism-editor
                                                    :value="jsonFormat(attr.value || 'N/A')"
                                                    class="my-editor"
                                                    :line-numbers="false"
                                                    :highlight="highlighter"
                                                    readonly
                                                />
                                                <div style="display: flex; justify-content: space-between">
                                                    <SupsisButton @click="copyTextToClipboard(attr.value || 'N/A')">
                                                        COPY JSON
                                                    </SupsisButton>
                                                    <SupsisButton @click="JSONModal = false"> CANCEL</SupsisButton>
                                                </div>
                                            </Modal2>
                                        </div>
                                        <div class="w-full" v-else>
                                            {{ attr.value || "N/A" }}
                                        </div>
                                    </div>
                                    <div class="flex centered">
                                        <button @click="copyTextToClipboard(attr.value || 'N/A')" class="copyButton">
                                            <a-icon type="copy" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <VisitorMetaReferralsCard
                            v-if="(selectedHistory.conversation.visitor.metaReferrals || []).length > 0"
                            :metaReferrals="selectedHistory.conversation.visitor.metaReferrals"
                        />
                        <VisitorCalendarCard :visitorId="selectedHistory.conversation.visitor._id" />
                        <div id="chatCard">
                            <div class="headtitle">
                                <span class="text">{{ $t("userInfoWidget.affiliatedRepresentatives") }} </span>
                            </div>
                            <div style="display: flex; align-items: center">
                                <a-tag
                                    color="orange"
                                    v-for="(user, i) of (selectedHistory.conversation.users.length > 0
                                        ? selectedHistory.conversation.users.slice(0, 3)
                                        : [selectedHistory.conversation.connectedUser]).filter(Boolean)"
                                    :key="i"
                                >
                                    {{ getUserHelper(user) }}
                                </a-tag>
                            </div>
                        </div>
                        <div id="chatCard">
                            <div class="headtitle">
                                <span class="text">{{ $t("userInfoWidget.preferredAgents") }}</span>
                            </div>
                            <PreferredAgents
                                v-if="selectedHistory.conversation.visitor"
                                :visitorId="selectedHistory.conversation.visitor._id"
                                v-model="selectedHistory.conversation.visitor.preferredAgents"
                            />
                        </div>
                        <div id="chatCard">
                            <div class="headtitle">
                                <span class="text">{{ $t("userInfoWidget.labels") }}</span>
                            </div>
                            <span>
                                <TagDialog v-model="cloneTags" />
                            </span>
                        </div>
                        <div id="chatCard">
                            <div class="headtitle">
                                <span class="text">{{ $t("userInfoWidget.agentNotes") }}</span>
                                <span class="ml-4"
                                    ><button v-if="!isNewNot" class="classic-button" @click="isNewNot = true">
                                        {{ $t("userInfoWidget.newNote") }}
                                    </button>
                                </span>
                            </div>
                            <div class="rep-note-element mt-2" v-if="isNewNot || !infoObj || !infoObj.noteSender">
                                <a-textarea v-model="infoObj.info" class="disableShortcut" />
                                <div class="rep-note-actions mt-1">
                                    <a-button-group size="small">
                                        <a-button
                                            class="classic-button mr-1"
                                            icon="close"
                                            type="danger"
                                            v-if="infoObj && infoObj.noteSender"
                                            @click="notSaveInfo"
                                        />
                                        <a-button
                                            class="classic-button"
                                            style="color: rgb(38, 233, 38)"
                                            icon="check"
                                            type="primary"
                                            @click="saveInfo"
                                        />
                                    </a-button-group>
                                </div>
                            </div>
                            <div
                                class="old-note"
                                v-if="infoObj && infoObj.noteSender"
                                @click="oldNoteIsOpen = !oldNoteIsOpen"
                            >
                                <button class="classic-button open-note">
                                    <span class="material-icons icon">{{ oldNoteIsOpen ? "remove" : "add" }}</span>
                                </button>
                                <span class="information"><b>1</b> {{ $t("userInfoWidget.available") }}</span>
                            </div>
                            <div v-if="oldNoteIsOpen && infoObj && infoObj.noteSender" class="old-note-desc">
                                <div class="top-header">
                                    <div class="agent-name">{{ infoObj.noteSender }}</div>
                                </div>
                                <div class="agent-note">{{ infoObj.info }}</div>
                            </div>
                        </div>
                        <div id="chatCard">
                            <div class="headtitle">
                                <span class="text">{{ $t("userInfoWidget.systemInformation") }}</span>
                            </div>
                            <div class="details-chat-card">
                                <div class="user-detail">
                                    <span
                                        class="icon material-icons"
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                        }"
                                        :content="$t('userInfoWidget.speechID')"
                                        >badge</span
                                    >
                                    <span>{{ selectedHistory.conversation._id }}</span>
                                </div>
                                <div class="user-detail">
                                    <span
                                        class="icon material-icons"
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                        }"
                                        :content="$t('userInfoWidget.customerVersion')"
                                        >info</span
                                    >
                                    <span>
                                        {{
                                            (
                                                selectedHistory.conversation.visitor.version || {
                                                    version: -1,
                                                    versionStr: "N/A",
                                                    buildNumber: -1,
                                                    commitHash: "",
                                                }
                                            ).versionStr
                                        }}
                                    </span>
                                </div>
                                <div class="user-detail" v-if="selectedHistory.conversation.ref !== 'whatsapp'">
                                    <span
                                        class="icon material-icons"
                                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                                        :content="$t('userInfoWidget.IPAddress')"
                                        >computer</span
                                    >
                                    <span
                                        v-if="
                                            !(
                                                !!selectedHistory.conversation.whatsappNumber ||
                                                !!selectedHistory.conversation.instagramUserId
                                            )
                                        "
                                    >
                                        {{ selectedHistory.conversation.ipAddress }}
                                    </span>
                                    <span
                                        style="width: 30px; height: 30px"
                                        v-if="selectedHistory.conversation.ref === 'instagram'"
                                    >
                                        <InstagramIcon :width="30" :height="30" />
                                    </span>
                                </div>
                                <div class="user-detail" v-if="selectedHistory.conversation.ref === 'whatsapp'">
                                    <span v-tippy="{ followCursor: true, placement: 'bottom-end' }" content="Whatsapp">
                                        <md-icon style="color: #06e576; font-size: 11px"> whatsapp </md-icon>
                                    </span>
                                    <p style="margin-left: 7px">{{ selectedHistory.conversation.whatsappNumber }}</p>
                                </div>

                                <div class="user-detail" v-if="getChannelName()">
                                    <span
                                        class="icon material-icons"
                                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                                        :content="$t('whatsappChannel.channelName')"
                                        >hub
                                    </span>
                                    <span>
                                        {{ getChannelName() }}
                                    </span>
                                </div>
                                <div class="user-detail" v-if="selectedHistory.conversation.ref !== 'whatsapp'">
                                    <span
                                        class="icon material-icons"
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                        }"
                                        :content="$t('userInfoWidget.pageVisited')"
                                        >public</span
                                    >
                                    <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                                        <a
                                            v-if="selectedHistory.conversation.visitingPage"
                                            :href="
                                                selectedHistory.conversation.visitingPage
                                                    ? selectedHistory.conversation.visitingPage
                                                    : '#'
                                            "
                                            class="info-label"
                                            target="_blank"
                                            >{{ selectedHistory.conversation.visitingPage }}</a
                                        >
                                        <span v-else>N/A</span>
                                    </span>
                                </div>
                                <div class="user-detail">
                                    <span
                                        class="icon material-icons"
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                        }"
                                        :content="$t('userInfoWidget.countryAndLanguage')"
                                        >map</span
                                    >
                                    <div class="d-flex" style="align-items: center">
                                        <country-flag
                                            v-if="
                                                getCountryCode(
                                                    $_.get(selectedHistory, 'conversation.geoLocation.country') ||
                                                        selectedHistory.conversation.languageCode
                                                )
                                            "
                                            v-tippy="{
                                                followCursor: true,
                                                placement: 'bottom-end',
                                                theme: isDarkMode ? 'light-border' : 'google',
                                            }"
                                            :content="
                                                getCountryName(
                                                    $_.get(selectedHistory, 'conversation.geoLocation.country') ||
                                                        selectedHistory.conversation.languageCode
                                                )
                                            "
                                            :country="
                                                getCountryCode(
                                                    $_.get(selectedHistory, 'conversation.geoLocation.country') ||
                                                        selectedHistory.conversation.languageCode
                                                )
                                            "
                                            size="normal"
                                            style="margin-top: -8px"
                                        />
                                        <span
                                            v-else
                                            v-tippy="{
                                                followCursor: true,
                                                placement: 'bottom-end',
                                                theme: isDarkMode ? 'light-border' : 'google',
                                            }"
                                            :content="
                                                getCountryName(
                                                    $_.get(selectedHistory, 'conversation.geoLocation.country') ||
                                                        selectedHistory.conversation.languageCode
                                                )
                                            "
                                        >
                                            {{
                                                selectedHistory.conversation.geoLocation
                                                    ? selectedHistory.conversation.geoLocation.country
                                                    : "N/A"
                                            }}
                                        </span>

                                        <span style="margin-left: 5px">
                                            {{ $_.get(selectedHistory.conversation, "languageCode", "").toUpperCase() }}
                                        </span>
                                    </div>
                                </div>
                                <div class="user-detail">
                                    <!--                                    <span
                                                                            class="icon material-icons"
                                                                            v-tippy="{
                                                                                followCursor: true,
                                                                                placement: 'bottom-end',
                                                                            }"
                                                                            :content="$t('userInfoWidget.systemAndBrowser')"
                                                                        >settings_suggest</span
                                                                        >-->
                                    <span
                                        v-if="
                                            !(
                                                selectedHistory.conversation.whatsappNumber ||
                                                selectedHistory.conversation.instagramUserId
                                            )
                                        "
                                    >
                                        <VisitorBrowserAndOs
                                            v-if="
                                                selectedHistory.conversation.visitor.os &&
                                                selectedHistory.conversation.visitor.browser
                                            "
                                            :visitor="selectedHistory.conversation.visitor"
                                        />
                                        <p v-else>
                                            {{ getUserDetailedLoginInfo(selectedHistory.conversation.userAgent) }}
                                        </p>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div id="chatCard" v-if="site._id === '5d14ee322d95ad001ebdf213'">
                            <div class="headtitle">
                                <span class="text">Flowlu Aktar</span>
                            </div>
                            <span>
                                <SupsisButton2 @click="flowluTransfer" primary>Chati Aktar</SupsisButton2>
                            </span>
                        </div>
                    </div>
                    <div class="text-center information-list2" style="padding: unset" v-else>
                        {{ $t("message.noMessageInChat") }}
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <Modal2
            v-if="isModalShow"
            id="visitor-message"
            :title="$t('message.visitorFeedback')"
            :show-footer="false"
            @cancel="hideModal"
        >
            <p class="my-4" style="word-wrap: break-word">
                {{ selectedHistory.conversation.description }}
            </p>
        </Modal2>
    </div>
</template>

<script>
import moment from "moment";
import { Settings } from "luxon";
import { mapActions, mapGetters, mapState } from "vuex";
import Info from "../../../components/svg/Info.vue";
import Representative from "../../../components/svg/Representative.vue";
import SendIcon from "../../../components/svg/SendIcon.vue";
import ChatId from "../../../components/svg/ChatId.vue";
import Operating from "../../../components/svg/Operating.vue";
import World from "../../../components/svg/World.vue";
import Ip from "../../../components/svg/Ip.vue";
import User from "../../../components/svg/User.vue";
import Mail from "../../../components/svg/Mail.vue";
import UserName from "../../../components/svg/UserName.vue";
import KeywordShortCut from "../../../components/svg/KeywordShortCut.vue";
import ConversationColor from "../../../components/svg/ConversationColor.vue";
import MessageList from "../../../components/popup-chat/MessageList.vue";
import * as _ from "lodash";
import $_ from "lodash";
import { log2 } from "../../../utils/log2";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import { toNewMessagesModel } from "../../../utils/chat";
import Avatar from "vue-avatar";
import PassedTimeCounterTimeFormat from "../../../components/PassedTimeCounterTimeFormat.vue";
import { i18n } from "../../../language";
import countryCodes from "../../../utils/countryCodes";
import Multiselect from "vue-multiselect";
import CountryFlag from "vue-country-flag";
import ChatBotIcon from "../../../components/fast-initialize/svg/ChatBotIcon.vue";
import TagDialog from "../../../components/TagDialog.vue";
import Chatbot from "../../../components/svg/Chatbot.vue";
import InstagramIcon from "../Chatbot/pages/integrations/svg/InstagramIcon.vue";
import WhatsappIcon from "../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import SupsisIcon from "../Chatbot/pages/integrations/svg/SupsisIcon.vue";
import TelegramIcon from "../Chatbot/pages/integrations/svg/TelegramIcon.vue";
import VisitorMiniFilterPreview from "../Visitors/VisitorMiniFilterPreview.vue";
import PreferredAgents from "../../../components/PreferredAgents.vue";
import SortIcon from "../../../components/svg/SortIcon.vue";
import Modal2 from "../../../components/common/Modal2.vue";
import languages from "../../../language/languages.json";
import VisitorBrowserAndOs from "../VisitorBrowserAndOs.vue";
import VisitorMetaReferralsCard from "../../../components/visitor/VisitorMetaReferralsCard.vue";
import VisitorCalendarCard from "../../../components/visitor/VisitorCalendarCard.vue";
import TimeUtils from "../../../utils/TimeUtils";
import Telegram from "../Settings/components/Telegram.vue";
import TwitterIcon from "../Chatbot/pages/integrations/svg/TwitterIcon.vue";
import { PrismEditor } from "vue-prism-editor";
import "prismjs/themes/prism.css";
import "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import SupsisButton from "../../../components/common/SupsisButtonOld.vue";
import MessengerIcon from "../Chatbot/pages/integrations/svg/MessengerIcon.vue";
import EmptyFilterResult from "../Chatbot/pages/archive/EmptyFilterResult.vue";
import SupsisButton2 from "../Settings/components/SupsisButton.vue";
import { transferFlowlu } from "../../../api/chat";
import CustomPicker from "../../../components/pickers/CustomPicker.vue";
import ChatWatcher from "../../../ChatWatcherV2";
import TrendyolIcon from "../Chatbot/pages/integrations/svg/TrendyolIcon.vue";
import { isMaskContactInfo, maskContactInfo } from "../../../utils/utils";
import ArchiveFilterBar from "../../../components/archive/ArchiveFilterBar.vue";

Settings.defaultLocale = i18n.locale;
const log = log2("Archives");
const defaultStartDate = () => moment().startOf("day").toISOString();
const defaultEndDate = () => moment().endOf("day").toISOString();
const refTypes = ["Whatsapp", "Supsis", "Instagram", "Telegram", "Messenger", "Trendyol"];
const destroyerTypes = ["Agent", "Visitor", "System", "Chatbot"];

export default {
    name: "Archives",
    components: {
        CustomPicker,
        SupsisButton2,
        SupsisButton,
        Telegram,
        InstagramIcon,
        TelegramIcon,
        Chatbot,
        TagDialog,
        User,
        Mail,
        Ip,
        World,
        Operating,
        ChatId,
        SendIcon,
        Representative,
        Info,
        KeywordShortCut,
        ConversationColor,
        MessageList,
        AppBreadCrumb,
        PassedTimeCounterTimeFormat,
        UserName,
        Avatar,
        CountryFlag,
        Multiselect,
        ChatBotIcon,
        VisitorMiniFilterPreview,
        PreferredAgents,
        SortIcon,
        Modal2,
        VisitorBrowserAndOs,
        WhatsappIcon,
        VisitorMetaReferralsCard,
        VisitorCalendarCard,
        SupsisIcon,
        TwitterIcon,
        PrismEditor,
        MessengerIcon,
        EmptyFilterResult,
        TrendyolIcon,
        ArchiveFilterBar,
    },
    data() {
        return {
            isCardVisible: true,
            dateDifferent: 1,
            currentPage: 1, // Şu anki sayfa numarası
            visibleChats: [], // Ekranda gösterilecek chatlerin listes
            perPage: 10,
            pageSizeChangerVisible: false,         
            // filters
            oldNoteIsOpen: false,
            lastNote: null,
            isNewNot: false,
            query: this.$route.query.query || null,
            scrollPositionOfConversationList: 0,
            selectedUser: this.$route.query.selectedUser || null,
            selectedDestroyers: this.$route.query.selectedDestroyers || null,
            selectedSite: this.$route.query.selectedSite || null,
            selectedVisitorId: this.$route.params.visitorId || null,
            startDate: this.$route.query.allTime
                ? null
                : this.$route.query.startDate
                ? moment(parseInt(this.$route.query.startDate)).toISOString()
                : defaultStartDate(),
            endDate: this.$route.query.allTime
                ? null
                : this.$route.query.endDate
                ? moment(parseInt(this.$route.query.endDate)).toISOString()
                : defaultEndDate(),
            point: parseInt(this.$route.query.point) || undefined,
            page: 1,
            selectedHistory: {
                conversation: {},
                visitor: {},
                messages: [],
                id: undefined,
            },
            selectedLang: "",
            filterDescription: this.$route.query.description === "true",
            filterVideoCall: this.$route.query.videoCall === "true",
            filterLostChats: this.$route.query.lostChats === "true",
            filterClosedByAgent: this.$route.query.closedByAgent === "true",
            timeSelect: this.$route.query.allTime ? "all-time" : this.$route.query.timeSelect || "today",
            wideScreen: false,
            selectedCustomDateFilter: this.$route.query.allTime ? "all-time" : "today",
            rowIndex: 0,
            renderCount: 0,
            usersFilter: [],
            cancels: [],
            multiSelectValue: (this.$route.query.refs || "")
                .split(",")
                .filter((x) => refTypes.includes(x))
                .map((x) => ({ name: x })),
            multiSelectOptions: refTypes.map((x) => {
                if (
                    x === "Whatsapp" ||
                    x === "Instagram" ||
                    x === "Supsis" ||
                    x === "Telegram" ||
                    x === "Messenger" ||
                    x === "Trendyol"
                )
                    return { name: x };
                else return { name: x, $isDisabled: true };
            }),
            destroyerMultiSelectValue: (this.$route.query.destroyers || "")
                .split(",")
                .filter((x) => destroyerTypes.includes(x))
                .map((x) => ({ name: x })),
            destroyerMultiSelectOptions: destroyerTypes.map((x) => {
                if (x === "Agent" || x === "Visitor" || x === "System" || x === "Chatbot") return { name: x };
                else return { name: x, $isDisabled: true };
            }),
            starterMultiSelectValue: (this.$route.query.starters || "")
                .split(",")
                .filter(Boolean)
                .map((x) => ({ name: x })),
            tagsMultiSelectValue: (this.$route.query.tags || "")
                .split(",")
                .filter(Boolean)
                .map(x => ({value: x, name: x})),
            isBusy: true,
            isScrolling: false,
            lastRegisteredMessages: [],
            fields: [
                {
                    key: "actions",
                    label: "",
                },
            ],
            maxDate: moment().toISOString(),
            lastFiveYear: moment().subtract(5, "year").toISOString(),
            isLoadingMore: false,

            phrases: {
                ok: "Tamam",
                cancel: "Vazgeç",
            },
            isLoading: false,
            lastPage: false,
            firstRequest: true,
            totalDataCount: 0,
            skeletonCount: 10,
            clickCount: 3, // ilk değer 20 den büyük limit elde ettirmeli ve yavaş artmalı.Bu nedenle 3 ten başlatıldı.
            pagination: {
                skipCount: 0,
                limit: this.$route.query.limit ? parseInt(this.$route.query.limit) : 10,
            },
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "#565867",
                },
            },
            infoObj: {
                info: "",
                noteSender: "",
                isEditingOpen: false,
                conversationId: "",
            },
            isModalShow: false,
            spinnerShow: false,
            selectedChatIdViewed: false,
            JSONModal: false,
            cloneTags: [],
        };
    },
    computed: {
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            myActiveConversations: "chat/getMyActiveConversations",
        }),
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            channels: (state) => state.channel.channels,
            users: (state) => state.user.users,
            isAdmin: (state) => state.auth.adminUser != null,
            visitors: (state) => {
                const vis = state.visitor.visitors;
                vis.data = _.uniqBy(vis.data, (q) => q._id);
                vis.data = _.sortBy(vis.data, (x) => moment(x.createdDate).toDate().getTime() * -1);
                return vis;
            },
            customerDomains: (state) => state.visitor.customerDomains,
            inputs: (state) =>
                state.customLoginForm.inputs.reduce((acc, cur) => {
                    acc[cur._id] = cur;
                    return acc;
                }, {}),
            subjects: (state) => state.subject.subjects.data,
            authUser: (state) => state.auth.user,
            selectedSubject: (state) => state.subject.selectedSubject,
            allTags: (state) => state.tag.tags.data.map((x) => ({ name: x.name, color: x.color, value: x._id })),
        }),
        filteredMessages() {
            return this.selectedHistory.messages.filter((m) => "undefined" === typeof m.type);
        },
        valueIds() {
            return this.multiSelectValue.map((v) => v.name).join(",");
        },
        selectTags(sa) {
            return this.tagsMultiSelectValue.map((v) => v.value).join(",");
        },
        selectDestroyer() {
            return this.destroyerMultiSelectValue.map((item) => item.name).join(",");
        },
        selectStarter() {
            return this.starterMultiSelectValue.map((item) => item.name).join(",");
        },
        tags() {
            return $_.get(this.selectedHistory, "conversation.visitor.tags", []).map((tag) => tag._id);
        },
        channelTypeMap() {
            return this.channels.reduce((acc, cur) => {
                acc[cur._id] = cur.type;
                return acc;
            }, {});
        },
    },
    methods: {
        ...mapActions({
            getVisitors: "visitor/getVisitors",
            loadOldMessages: "chat/loadOldMessages",
            getUser: "user/getUser",
            getUsers: "user/getUsers",
            addNoteToConversation: "chat/addNoteToConversation",
            getTags: "tag/getTags",
            listChannels: "channel/listChannels",
            updateTagVisitor: "visitor/updateTagVisitor",
        }),
        isMaskContactInfo,
        maskContactInfo(key, val, length = 4) {
            return this.isMaskContactInfo(key) ? maskContactInfo(val, length) : val;
        },
        maskContactFullname(fullname, conversation) {
            return fullname === _.get(conversation, "visitor.phone") ||
                fullname === _.get(conversation, "visitor.email") ||
                fullname === _.get(conversation, "visitor.whatsappNumber")
                ? this.maskContactInfo("phone", fullname)
                : fullname;
        },
        flowluTransfer() {
            transferFlowlu(this.selectedHistory.conversation._id).then(() => {
                this.$toasted.show("Chat bilgileri flowluya aktarıldı.", {
                    duration: 3000,
                    position: "top-center",
                });
            });
        },
        pageChange(cur, sel) {
            this.pagination.skipCount = cur - 1;
            this.pagination.limit = sel;
        },
        decrease() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.pagination.skipCount = this.pagination.limit * (this.currentPage - 1);
                this.getHistory();
            }
        },
        decreaseAll() {
            this.currentPage = 1;
            this.pagination.skipCount = this.pagination.limit * (this.currentPage - 1);
            this.getHistory();
        },
        increase() {
            if (this.currentPage < this.visitors.pageCount) {
                this.currentPage++;
                this.pagination.skipCount = this.pagination.limit * (this.currentPage - 1);
                this.getHistory();
            }
        },
        increaseAll() {
            this.currentPage = this.visitors.pageCount;
            this.pagination.skipCount = this.pagination.limit * (this.currentPage - 1);
            this.getHistory();
        },
        isWABusiness() {
            const channelId = _.get(this.selectedHistory, "conversation.channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-business-api";
        },
        isWhatsappV1() {
            const channelId = _.get(this.selectedHistory, "conversation.channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-v1" || _.get(channel, "type") === "whatsapp-qr";
        },
        isWhatsappV2() {
            const channelId = _.get(this.selectedHistory, "conversation.channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-v2";
        },
        isWhatsappV3() {
            const channelId = _.get(this.selectedHistory, "conversation.channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-unipile";
        },
        isInstagram() {
            const channelId = _.get(this.selectedHistory, "conversation.channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "instagram";
        },
        isMessenger() {
            const channelId = _.get(this.selectedHistory, "conversation.channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "messenger";
        },
        isTelegram() {
            const channelId = _.get(this.selectedHistory, "conversation.channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "telegram-unipile";
        },
        isLinkedin() {
            const channelId = _.get(this.selectedHistory, "conversation.channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "linkedin-unipile";
        },
        isWebContact() {
            return (
                _.get(this.selectedHistory, "conversation.ref") === "web" ||
                !!_.get(this.selectedHistory, "conversation.ref")
            );
        },
        startInstagramChat() {
            const channelId = _.get(this.selectedHistory, "conversation.channel");
            const instagramUserId = _.get(this.selectedHistory, "conversation.instagramUserId");
            ChatWatcher.startChatImmediately({
                instagramUserId,
                channelId,
                channelType: this.channelTypeMap[channelId],
            });
        },
        startTelegramChat() {
            const channelId = _.get(this.selectedHistory, "conversation.channel");
            const telegramUserId = _.get(this.selectedHistory, "conversation.telegramUserId");
            ChatWatcher.startChatImmediately({
                telegramUserId,
                channelId,
                channelType: this.channelTypeMap[channelId],
            });
        },
        startLinkedinChat() {
            const channelId = _.get(this.selectedHistory, "conversation.channel");
            const linkedinUserId = _.get(this.selectedHistory, "conversation.linkedinUserId");
            ChatWatcher.startChatImmediately({
                linkedinUserId,
                channelId,
                channelType: this.channelTypeMap[channelId],
            });
        },
        startMessengerChat() {
            const channelId = _.get(this.selectedHistory, "conversation.channel");
            const messengerUserId = _.get(this.selectedHistory, "conversation.messengerUserId");
            ChatWatcher.startChatImmediately({
                messengerUserId,
                channelId,
                channelType: this.channelTypeMap[channelId],
            });
        },
        startWhatsappChat() {
            const channelId = _.get(this.selectedHistory, "conversation.channel");
            const whatsappNumber = _.get(this.selectedHistory, "conversation.whatsappNumber");
            if (!whatsappNumber) return;
            if (!channelId) return;

            ChatWatcher.startChatImmediately({
                whatsappNumber: whatsappNumber,
                channelId: channelId,
                channelType: this.channelTypeMap[channelId],
            });
        },
        startWebChat() {
            const visitorId = _.get(this.selectedHistory, "conversation.visitor._id");
            if (!visitorId) return;

            ChatWatcher.startChatImmediately({
                visitorId: visitorId,
            });
        },
        showModal() {
            this.isModalShow = true;
        },
        hideModal() {
            this.isModalShow = false;
        },
        removeSelectedVisitorIDFilter() {
            this.selectedVisitorId = null; // selectedVisitorId'yi sıfırlayın
            this.getHistory(); // Filtreleri sıfırladıktan sonra geçmişi yeniden yükleyin
        },
        getUserDetailedLoginInfo(uaString) {
            const parser = require("ua-parser-js");
            const ua = parser(uaString || "-");
            return `${ua.os.name} ${ua.os.version} | ${ua.browser.name} ${ua.browser.major}`;
        },
        openInChatbot() {
            this.$router.push(`/chatbot/archive?visitorId=${_.get(this.selectedHistory, "conversation.visitor._id")}`);
        },
        noop() {},
        seeAll() {
            this.selectedVisitorId = this.selectedHistory.conversation.visitor._id;
            this.$router.push(`/archives/${this.selectedHistory.conversation.visitor._id}?allTime=1`);
        },
        getEmail(data) {
            // log("getEmail", data);
            try {
                const email = !!data.email
                    ? data.email.substr(0, 15) + "..."
                    : !!data.customLoginInfos && data.customLoginInfos.length > 0
                    ? data.customLoginInfos
                          .find(
                              (l) => l.input === Object.keys(this.inputs).find((x) => this.inputs[x].type === "email")
                          )
                          .value.substr(0, 15) + "..."
                    : "-";
                return this.maskContactInfo("email", email, 5);
            } catch (e) {
                return "-";
            }
        },

        getCountryCode(country) {
            // log("getCountryCode", country);
            if (!country) return undefined;
            country = country.trim().toLowerCase();
            if (country.length <= 3) {
                return country;
            } else {
                const maybeCounty = countryCodes.find((x) => x.name.toLowerCase().trim() === country);
                return maybeCounty ? maybeCounty.code : undefined;
            }
        },
        getCountryName(country = "") {
            // log("getCountryName", country);
            const q = country.toLowerCase().trim();
            const maybeCountry = countryCodes.find(
                (x) => x.name.toLowerCase().trim() === q || x.code.toLowerCase().trim() === q
            );
            return maybeCountry ? maybeCountry.name : country;
        },
        getCustomLoginInfos() {
            let inputValues = this.selectedHistory.conversation.customLoginInfos || [];
            log.debug("getCustomLoginInfos called", {
                inputs: this.inputs,
                inputValues,
            });
            const hashMapContactProperty = (this.selectedHistory.conversation.visitor?.contactProperties || []).reduce(
                (a, b) => {
                    a[b.property._id] = true;
                    return a;
                },
                {}
            );
            inputValues = inputValues
                .filter((v) => this.inputs[v.input] && !!v.value)
                .filter((x) => !["email", "fullname", "subject"].includes(this.inputs[x.input].type))
                .filter((x) => !hashMapContactProperty[this.inputs[x.input]?.contactProperty])
                .map((v) => {
                    const object = _.get(this.inputs[v.input], "localizedLabel", {}) || {};
                    const validLangs = Object.keys(object);
                    const lang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
                    const customLoginFormLabelTitle = _.get(this.inputs[v.input], `localizedLabel.${lang}.text`, "");
                    return {
                        value: this.inputs[v.input].type === "subject" ? this.getSubjectName(v.value) : v.value,
                        name: customLoginFormLabelTitle,
                    };
                });
            return inputValues;
        },
        getSubjectName(id) {
            // log("getSubjectName", id);
            if (!id) {
                return "-";
            }
            let maybeSubject = this.subjects.find((x) => x._id === id);
            if (maybeSubject) {
                const validLangs = Object.keys(maybeSubject.languageContent);
                const lang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
                return _.get(maybeSubject, `languageContent.${lang}.name`, "");
            }
            return "";
        },
        setCustomDateFilter(filter) {
            //console.log("setCustomDateFilter ", filter);
            this.allowCustomDate = false;
            if (filter === "today") {
                this.startDate = moment().startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "yesterday") {
                this.startDate = moment().subtract(1, "days").startOf("day").toISOString();
                this.endDate = moment().subtract(1, "days").endOf("day").toISOString();
            } else if (filter === "current-week") {
                this.startDate = moment().startOf("week").startOf("day").toISOString();
                this.endDate = moment().endOf("week").endOf("day").toISOString();
            } else if (filter === "last-week") {
                this.startDate = moment().startOf("isoWeeks").subtract(1, "days").startOf("isoWeeks").toISOString();
                this.endDate = moment().startOf("isoWeeks").subtract(1, "days").endOf("isoWeeks").toISOString();
            } else if (filter === "current-month") {
                this.startDate = moment().startOf("month").startOf("day").toISOString();
                this.endDate = moment().endOf("month").endOf("day").toISOString();
            } else if (filter === "last-month") {
                this.startDate = moment().startOf("month").subtract(1, "days").startOf("month").toISOString();
                this.endDate = moment().startOf("month").subtract(1, "days").endOf("month").toISOString();
            } else if (filter === "last-30") {
                this.startDate = moment().subtract(30, "days").startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "all-time") {
                this.startDate = null;
                this.endDate = null;
            } else if (typeof filter === "object") {
                this.startDate = filter.start;
                this.endDate = filter.end;
            }
        },
        getLast11Months() {
            return TimeUtils.getLast11Months();
        },
        getParticipants() {
            const supportUsers = this.filteredMessages
                .filter((x) => x.messageType === "user" || x.messageType === "private")
                .map((x) => ({
                    id: x.userId,
                    name: x.username,
                }));

            return _.uniqBy(supportUsers, (q) => q.name);
        },

        getMessages() {
            let allMessages = toNewMessagesModel(this.filteredMessages, this);
            if (this.typingMessage) {
                allMessages = [
                    ...allMessages,
                    {
                        type: "typing",
                        data: {
                            text: this.typingMessage,
                        },
                    },
                ];
            }
            return allMessages;
        },
        fetchAllUsers() {
            this.getUsers({ perPage: 1000, page: 1 }).then((response) => {
                log("getUsers completed", response.data);
                this.usersFilter = response.data;
            });
        },
        getUserHelper(userObjectOrUserId) {
            const isUserObject = typeof userObjectOrUserId === "object";
            const isUserId = typeof userObjectOrUserId === "string";
            if (isUserObject) {
                return userObjectOrUserId.name;
            } else if (isUserId) {
                let newUser = "-";
                const maybeUserObj = this.users.data.find((x) => x._id === userObjectOrUserId);
                if (maybeUserObj) {
                    newUser = maybeUserObj.name;
                }
                log("getUserHelper", userObjectOrUserId, newUser, maybeUserObj);
                return newUser;
            } else {
                return "-";
            }
        },
        handleFiltersChange(filters) {
            this.query = filters.query;
            this.selectedSite = filters.selectedSite;
            this.multiSelectValue = filters.multiSelectValue;
            this.destroyerMultiSelectValue = filters.destroyerMultiSelectValue;
            this.starterMultiSelectValue = filters.starterMultiSelectValue;
            this.tagsMultiSelectValue = filters.tagsMultiSelectValue;
            this.point = filters.point;
            this.startDate = filters.startDate;
            this.endDate = filters.endDate;
            this.timeSelect = filters.timeSelect;
            this.filterDescription = filters.filterDescription;
            this.filterVideoCall = filters.filterVideoCall;
            this.filterLostChats = filters.filterLostChats;
            this.filterClosedByAgent = filters.filterClosedByAgent;
            this.selectedUser = filters.selectedUser;

            this.getHistory(true);
        },
        resetFilters() {
            this.timeSelect = "today";
            this.startDate = defaultStartDate();
            this.endDate = defaultEndDate();
            this.query = null;
            this.selectedUser = null;
            this.selectedSite = null;
            this.multiSelectValue = [];
            this.tagsMultiSelectValue = [];
            this.destroyerMultiSelectValue = [];
            this.starterMultiSelectValue = [];
            this.selectedVisitorId = null;
            this.filterDescription = false;
            this.filterVideoCall = false;
            this.filterLostChats = false;
            this.filterClosedByAgent = false;
            this.filterWhatsappConversations = false;
            this.filterInstagramConversations = false;
            this.filterTelegramConversations = false;
            this.point = null;

            this.getHistory(true);
        },
        getHistory(resetPage = false, customPage = undefined, customPerPage = undefined) {
            if (this.fetchTimerId) clearTimeout(this.fetchTimerId);
            this.fetchTimerId = setTimeout(() => {
                this.performGetHistory(resetPage, customPage, customPerPage);
            }, 300);
        },
        performGetHistory(resetPage = false, customPage = undefined, customPerPage = undefined) {
            if (resetPage) {
                this.pagination.skipCount = 0;
                this.isLoadingMore = false;
                this.visitors.data = [];
            } else if (this.isLoadingMore) {
                this.isLoadingMore = false;
            }
            if (customPage) this.pagination.skipCount = customPage;
            if (customPerPage) this.pagination.limit = customPerPage;
            const startDate = new Date(this.startDate).getTime();
            const endDate = new Date(this.endDate).getTime();
            if (startDate && endDate) {
                this.selectedCustomDateFilter = null;
            }
            this.updateQueryParams("skipCount", this.pagination.skipCount);
            this.updateQueryParams("limit", this.pagination.limit);
            this.updateQueryParams("startDate", startDate ? startDate : null);
            this.updateQueryParams("endDate", endDate ? endDate : null);
            this.updateQueryParams("selectedUser", this.selectedUser);
            this.updateQueryParams("selectedSite", this.selectedSite);
            this.updateQueryParams("refs", this.valueIds);
            this.updateQueryParams("tags", this.selectTags);
            this.updateQueryParams("destroyers", this.selectDestroyer);
            this.updateQueryParams("starters", this.selectStarter);
            this.updateQueryParams("query", this.query);
            this.updateQueryParams("point", this.point ? this.point : null);
            this.updateQueryParams("videoCall", this.filterVideoCall ? this.filterVideoCall : null);
            this.updateQueryParams("lostChats", this.filterLostChats ? this.filterLostChats : null);
            this.updateQueryParams("closedByAgent", this.filterClosedByAgent ? this.filterClosedByAgent : null);
            this.updateQueryParams("description", this.filterDescription ? this.filterDescription : null);
            this.updateQueryParams("allTime", this.selectedCustomDateFilter === "all-time" ? "1" : null);
            this.spinnerShow = true;
            return this.getVisitors({
                limit: this.pagination.limit,
                skipCount: this.pagination.skipCount,
                startDate: this.startDate,
                endDate: this.endDate,
                query: this.query,
                point: this.point,
                description: this.filterDescription,
                videoCall: this.filterVideoCall,
                userId: this.selectedUser,
                homeSite: this.selectedSite,
                refs: this.valueIds,
                infinityScroll: !resetPage,
                lostChats: this.filterLostChats,
                closedByAgent: this.filterClosedByAgent,
                visitorId: this.selectedVisitorId,
                tags: this.selectTags,
                destroyers: this.selectDestroyer,
                starters: this.selectStarter,
            })
                .then((data) => {
                    this.currentPage = data.total > 0 ? this.currentPage : 1;
                    this.totalDataCount = data.total;
                    if (this.$route.query.selectedChatId && !this.selectedChatIdViewed) {
                        this.selectedChatIdViewed = true;
                        this.view(this.$route.query.selectedChatId);
                    }
                })
                .finally(() => {
                    this.spinnerShow = false;
                    log("current all data length and last all data length", {
                        vd: this.visitors.data.length,
                        c: this.totalDataCount,
                    });
                    this.lastPage = this.totalDataCount === this.visitors.data.length;
                    this.renderCount += 1;
                    setTimeout(() => {
                        this.isBusy = false;
                        this.isScrolling = false;
                        /*
                        Chat arşivini sayfa yüklendikten sonra en aşağıya kaydırma özelliği kaldırıldı
                        const conversationListTag = document.getElementById("conversation-list");
                        if (!!conversationListTag) {
                            conversationListTag.scrollTop = conversationListTag.scrollHeight;
                        }*/
                    }, 1000);
                });
        },
        view(id) {
            if (this.selectedHistory.id !== id) {
                const maybeConversation = this.visitors.data.find((v) => v._id === id);
                if (maybeConversation) {
                    this.selectedHistory.conversation = maybeConversation;
                    this.selectedHistory.id = id;
                    this.updateQueryParams("selectedChatId", id);
                    this.rowIndex = this.visitors.data.findIndex((v) => v._id === id);
                    this.isLoading = true;
                    this.loadOldMessages(id).then((response) => {
                        this.isLoading = false;
                        let items = response.data.data;
                        items = _.orderBy(
                            _.uniqBy(items, (q) => q._id || q.uniqMessageId),
                            (q) => moment(q.createdDate).toDate().getTime(),
                            "asc"
                        );
                        this.selectedHistory.messages = items;
                        log("view", this.selectedHistory);
                    });
                    setTimeout(() => {
                        const row = document.querySelector("tr.table-active");
                        if (row) {
                            document.getElementById("conversation-list").scrollTop = row.offsetTop;
                        }
                    }, 200);
                }
            }
        },
        reset() {
            this.selectedHistory = {
                visitor: {},
                conversation: {},
                messages: [],
                id: undefined,
            };
        },
        rowClass(item, type) {
            if (item && type === "row") {
                if (this.selectedHistory.conversation._id === item._id) {
                    return "table-active";
                } else {
                    return null;
                }
            } else {
                return null;
            }
        },
        addMessage(data) {
            let mergeString = "";
            let lastDateM;
            let dateM;
            if (data.userId != undefined) {
                data.user = data.userId;
            }
            if (this.messages.length > 1) {
                lastDateM = moment(
                    String(
                        this.messages[this.messages.length - 1].date ||
                            this.messages[this.messages.length - 1].createdDate
                    )
                ).format("HH:mm");
                dateM = moment(String(data.date || data.createdDate)).format("HH:mm");

                if (data.visitor !== undefined && this.messages[this.messages.length - 1].visitor === data.visitor) {
                    mergeString = "\n";
                } else if (data.user !== undefined && this.messages[this.messages.length - 1].user === data.user) {
                    mergeString = "<br />";
                } else if (
                    data.visitorId !== undefined &&
                    this.messages[this.messages.length - 1].visitorId === data.visitorId
                ) {
                    mergeString = "\n";
                } else if (
                    data.userId !== undefined &&
                    this.messages[this.messages.length - 1].userId === data.userId
                ) {
                    mergeString = "<br />";
                }
            }

            if (
                mergeString !== "" &&
                lastDateM === dateM &&
                this.messages[this.messages.length - 1].messageType === data.messageType
            ) {
                const messageText = data.message || data.description;
                if (this.messages[this.messages.length - 1].message !== undefined) {
                    this.messages[this.messages.length - 1].message += mergeString + messageText;
                } else if (this.messages[this.messages.length - 1].description !== undefined) {
                    this.messages[this.messages.length - 1].description += mergeString + messageText;
                }
                this.emptyMessages.push("");
            } else {
                let isPush = true;
                let lastMessageSystemType = this.messages[this.messages.length - 1];
                if (
                    lastMessageSystemType != null &&
                    lastMessageSystemType.systemMessageType === "customer-online" &&
                    data.systemMessageType === "customer-offline"
                ) {
                    isPush = false;
                } else if (
                    lastMessageSystemType != null &&
                    lastMessageSystemType.systemMessageType === "customer-offline" &&
                    data.systemMessageType === "customer-online"
                ) {
                    isPush = false;
                }
                if (isPush) {
                    this.messages.push(data);
                } else {
                    this.messages[this.messages.length - 1].isHide = true;
                }
            }
        },
        queryChanged: _.debounce(function (newQuery, oldQuery) {
            log("queryChanged", { newQuery, oldQuery });
            if (newQuery !== oldQuery) {
                this.getHistory(true);
            }
        }, 1000),
        updateQueryParams(key, value) {
            if (value === "" || value == null) {
                let query = Object.assign({}, this.$route.query);
                delete query[key];
                this.$router.replace({ query });
            } else {
                let { query } = this.$route;
                this.$router.replace({
                    query: { ...query, [key]: encodeURI(value) },
                });
            }
        },
        detectWideScreen() {
            let width = document.body.clientWidth;
            if (width < 1100) {
                this.wideScreen = false;
            } else {
                this.wideScreen = true;
            }
        },
        saveInfo() {
            let payload = {
                id: this.infoObj.conversationId,
                representativeNote: this.infoObj.info,
                representativeName: this.authUser.name,
                isArchive: true,
            };
            log("save info", payload);
            this.addNoteToConversation(payload).then(() => {
                this.infoObj.noteSender = this.authUser.name;
                this.infoObj.isEditingOpen = false;
                this.lastNote = this.selectedHistory.conversation.note;
                this.oldNoteIsOpen = true;
                this.isNewNot = false;
            });
        },
        notSaveInfo() {
            this.infoObj.info = this.selectedHistory.conversation.note.representativeNote;
            this.infoObj.isEditingOpen = false;
            this.isNewNot = false;
        },
        copyTextToClipboard(str) {
            const el = document.createElement("textarea");
            el.value = str;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            this.$message.success(this.$t("message.copiedClipboard"));
        },
        changePerPage(val) {
            this.perPage = val;
            this.pagination.limit = val;
            this.pagination.skipCount = 0;
            this.getHistory(true);
        },
        decreaseDate() {
            const diffDays = moment(this.endDate).diff(moment(this.startDate), "days");
            let period = diffDays < 6 ? "days" : diffDays < 28 ? "weeks" : diffDays < 360 ? "months" : "years";

            this.startDate = moment(this.startDate).subtract(1, period).toISOString();
            this.endDate = moment(this.endDate).subtract(1, period).toISOString();
        },
        incrementDate() {
            const diffDays = moment(this.endDate).diff(moment(this.startDate), "days");
            let period = diffDays < 6 ? "days" : diffDays < 28 ? "weeks" : diffDays < 360 ? "months" : "years";

            this.startDate = moment(this.startDate).add(1, period).toISOString();
            this.endDate = moment(this.endDate).add(1, period).toISOString();
        },
        dateDifferentCalculator(start, end, param) {
            let momentStart = moment(start);
            let momentEnd = moment(end);
            this.dateDifferent = momentStart.diff(momentEnd, param);
        },
        getChannelName() {
            const result = this.channels.find((x) => x._id === this.selectedHistory.conversation.channel);
            return result?.name;
        },
        changeTitleName(startDate, endDate) {
            if (
                startDate === moment().startOf("day").toISOString() &&
                endDate === moment().endOf("day").toISOString()
            ) {
                this.timeSelect = "today";
            } else if (
                startDate === moment().subtract(1, "days").startOf("day").toISOString() &&
                endDate === moment().subtract(1, "days").endOf("day").toISOString()
            ) {
                this.timeSelect = "yesterday";
            } else if (
                startDate === moment().startOf("week").startOf("day").toISOString() &&
                endDate === moment().endOf("week").endOf("day").toISOString()
            ) {
                this.timeSelect = "current-week";
            } else if (
                startDate === moment().startOf("isoWeeks").subtract(1, "days").startOf("isoWeeks").toISOString() &&
                endDate === moment().startOf("isoWeeks").subtract(1, "days").endOf("isoWeeks").toISOString()
            ) {
                this.timeSelect = "last-week";
            } else if (
                startDate === moment().startOf("month").startOf("day").toISOString() &&
                endDate === moment().endOf("month").endOf("day").toISOString()
            ) {
                this.timeSelect = "current-month";
            } else if (
                startDate === moment().startOf("month").subtract(1, "days").startOf("month").toISOString() &&
                endDate === moment().startOf("month").subtract(1, "days").endOf("month").toISOString()
            ) {
                this.timeSelect = "last-month";
            } else if (
                startDate === moment().subtract(30, "days").startOf("day").toISOString() &&
                endDate === moment().endOf("day").toISOString()
            ) {
                this.timeSelect = "last-30";
            } else if (startDate === null && endDate === null) {
                this.timeSelect = "all-time";
            } else {
                let titleChanged = false;
                this.getLast11Months().map((m) => {
                    if (m.date.start === startDate && m.date.end === endDate) {
                        this.timeSelect = m.date;
                        titleChanged = true;
                    }
                });
                if (!titleChanged) {
                    this.timeSelect = "custom";
                }
            }
        },
        highlighter(code) {
            return Prism.highlight(code, Prism.languages.javascript, "javascript");
        },
        jsonFormat(json) {
            try {
                JSON.stringify(JSON.parse(json), null, 4);
            } catch (e) {
                return json;
            }
        },
        getAgentsOptions() {
            let items = _.get(this, "usersFilter.data", []) || [];
            items = items.map((item) => {
                return {
                    id: item._id,
                    label: item.name,
                };
            });
            items = [
                {
                    id: null,
                    label: this.$t("message.allUsers"),
                },
                {
                    id: "only-chatbot",
                    label: this.$t("message.chatBot"),
                },
                ...items,
            ];
            return items;
        },
    },
    mounted() {
        // const savedFilters = localStorage.getItem("filters");
        //
        // if (savedFilters) {
        //     const filters = JSON.parse(savedFilters);
        //     this.startDate = filters.startDate;
        //     this.endDate = filters.endDate;
        //     this.query = filters.query;
        //     this.selectedUser = filters.selectedUser;
        //     this.selectedSite = filters.selectedSite;
        //     this.selectedRefs = filters.selectedRefs;
        //     this.selectedTags = filters.selectedTags;
        //     this.selectedVisitorId = filters.selectedVisitorId;
        //     this.point = filters.point;
        // }

        this.cloneTags = _.cloneDeep(this.tags) || [];

        this.listChannels();
        this.fetchAllUsers();
        this.getCustomLoginInfos();
        let conversationList = document.getElementById("conversation-list");
        conversationList.scrollTop = conversationList.scrollHeight;

        const customPage = this.$route.query.skipCount ? 0 : undefined;
        const customPerPage = this.$route.query.skipCount
            ? parseInt(this.$route.query.skipCount) * this.pagination.limit
            : undefined;

        this.selectedLang = languages.find((lang) => lang.code === this.selectedHistory.visitor.preferredLang);

        this.getTags().then(() => {
            this.tagsMultiSelectValue = this.allTags.filter((tag) => this.tagsMultiSelectValue.map(s => s.value).includes(tag.value));
            this.getHistory(false, customPage, customPerPage);
        });
        const keydownCallback = (e) => {
            if (e.key === "ArrowDown" && (e.ctrlKey || e.metaKey)) {
                if (this.rowIndex === this.visitors.data.length - 1) {
                    const conversationList = document.getElementById("conversation-list");
                    if (
                        Math.ceil(conversationList.scrollTop) ==
                        conversationList.scrollHeight - conversationList.clientHeight
                    ) {
                        const button = document.getElementById("archive-load-more-btn");
                        if (button) button.focus();
                    }
                }
                const chat = this.visitors.data[this.rowIndex + 1];
                if (chat) {
                    this.view(chat._id, this.rowIndex + 1);
                }
                e.preventDefault();
            } else if (e.key === "ArrowUp" && (e.ctrlKey || e.metaKey)) {
                if (this.rowIndex > 0) {
                    const chat = this.visitors.data[this.rowIndex - 1];
                    if (chat) {
                        this.view(chat._id, this.rowIndex - 1);
                    }

                    if (this.visitors.data.length - 1 > this.rowIndex) {
                        const button = document.getElementById("archive-load-more-btn");
                        if (button) button.blur();
                    }
                }
                e.preventDefault();
            }
        };
        const resizeCallback = this.detectWideScreen;
        window.addEventListener("keydown", keydownCallback);
        window.addEventListener("resize", resizeCallback);
        this.cancels.push(() => {
            window.removeEventListener("keydown", keydownCallback);
            window.removeEventListener("resize", resizeCallback);
        });
        this.detectWideScreen();
        // console.log('multiSelect', {asd:this.multiSelectOptions})
    },
    beforeDestroy() {
        this.reset();
        this.$router.replace({ query: null });
        this.cancels.forEach((cancel) => cancel());
        // const filters = {
        //     startDate: this.startDate,
        //     endDate: this.endDate,
        //     query: this.query,
        //     selectedUser: this.selectedUser,
        //     selectedSite: this.selectedSite,
        //     selectedRefs: this.selectedRefs,
        //     selectedTags: this.selectedTags,
        //     selectedVisitorId: this.selectedVisitorId,
        //     point: this.point,
        // };
        // localStorage.setItem("filters", JSON.stringify(filters));
    },
    updated() {
        log("updated", this.selectedHistory);
    },
    watch: {
        cloneTags(val) {
            if (!!_.get(this.selectedHistory, "conversation.visitor._id")) {
                this.updateTagVisitor({
                    visitorId: _.get(this.selectedHistory, "conversation.visitor._id"),
                    tagIds: val,
                });
            }
        },
        currentPage(newVal) {
            if (newVal > this.visitors.pageCount) {
                this.currentPage = this.visitors.pageCount;
            } else if (newVal < 1) {
                this.currentPage = 1;
            }
            this.pagination.skipCount = this.pagination.limit * (this.currentPage - 1);
            this.getHistory();
        },
        selectedVisitorId(newValue, oldValue) {
            log("selectedVisitorId updated", newValue);
            this.pagination.skipCount = 0;
            this.getHistory(true);
        },
        startDate(newValue, oldValue) {
            this.changeTitleName(newValue, this.endDate);
            if (true || newValue) {
                log("startDate updated", newValue);
                this.pagination.skipCount = 0;
                this.getHistory(true);
            }
        },
        endDate(newValue, oldValue) {
            this.changeTitleName(this.startDate, newValue);
            if (true || newValue) {
                log("endDate updated", newValue);
                this.pagination.skipCount = 0;
                this.getHistory(true);
            }
        },
        selectedUser(newValue, oldValue) {
            log("selectedUser updated", newValue);
            this.pagination.skipCount = 0;
            this.getHistory(true);
        },
        pagination(newValue, oldValue) {
            this.getHistory(true);
        },
        selectedSite(newValue) {
            this.getHistory(true);
        },
        query(newValue, oldValue) {
            log("query updated", newValue);
            this.queryChanged(newValue, oldValue);
            this.query = newValue;
        },
        point(newValue, oldValue) {
            log("query updated", newValue);
            this.point = newValue;
            this.getHistory(true);
        },
        filterDescription(newValue) {
            this.filterDescription = newValue;
            this.getHistory(true);
        },
        filterVideoCall(newValue) {
            this.filterVideoCall = newValue;
            this.getHistory(true);
        },
        filterLostChats(newValue) {
            this.filterLostChats = newValue;
            this.getHistory(true);
        },
        filterClosedByAgent(newValue) {
            this.filterClosedByAgent = newValue;
            this.getHistory(true);
        },
        filterWhatsappConversations(newValue) {
            this.filterWhatsappConversations = newValue;
            if (newValue === true) {
                this.selectedRefs = "Whatsapp";
            } else {
                this.selectedRefs = "";
            }
            log("selectedRefs updated", newValue);
            this.getHistory(true);
        },
        filterInstagramConversations(newValue) {
            this.filterInstagramConversations = newValue;
            if (newValue === true) {
                this.selectedRefs = "Instagram";
            } else {
                this.selectedRefs = "";
            }
            log("selectedRefs updated", newValue);
            this.getHistory(true);
        },
        filterTelegramConversations(newValue) {
            this.filterTelegramConversations = newValue;
            if (newValue === true) {
                this.selectedRefs = "Telegram";
            } else {
                this.selectedRefs = "";
            }
            log("selectedRefs updated", newValue);
            this.getHistory(true);
        },
        visitors: {
            handler(newValue, oldValue) {
                log("visitors updated", newValue, this.selectedHistory);
                if (newValue && newValue.data) {
                    if (newValue.data.length > 0) {
                        const selectedChatIdFromParam = this.$route.query.selectedChatId;
                        log.debug("selectedChatIdFromParam", {
                            selectedChatIdFromParam,
                            exists: newValue.data.find((v) => v._id === selectedChatIdFromParam),
                        });
                        if (selectedChatIdFromParam && newValue.data.find((v) => v._id === selectedChatIdFromParam)) {
                            this.view(selectedChatIdFromParam);
                        } else {
                            if (this.selectedHistory.conversation._id !== newValue.data[0]._id)
                                this.view(newValue.data[0]._id);
                        }
                    }
                    if (newValue.data.length === 0) {
                        this.selectedHistory = {
                            conversation: {},
                            visitor: {},
                            messages: [],
                            id: undefined,
                        };
                    }
                }
            },
            deep: true,
        },
        timeSelect(newVal) {
            this.setCustomDateFilter(newVal);
        },
        "selectedHistory.conversation": function (newVal, oldVal) {
            log("selectedHistory.conversation changed");
            this.cloneTags = _.cloneDeep(this.tags) || [];

            let maybeNote = newVal.note;
            if (!!maybeNote) {
                if (newVal._id !== this.infoObj.conversationId) {
                    this.infoObj.info = newVal.note.representativeNote;
                    this.infoObj.noteSender = newVal.note.representativeName;
                    this.infoObj.conversationId = newVal._id;
                }
            } else {
                this.infoObj.info = "";
                this.infoObj.noteSender = "";
                this.infoObj.conversationId = newVal._id;
            }
        },
        selectedSubject(newVal) {
            log("selectedSubject changed", newVal);
            this.getHistory(true);
        },
    },
};
</script>
<style src="../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
#visitor-list-table {
    display: block;
    width: 100%;

    tbody {
        display: block;

        tr {
            display: block;

            td {
                display: block;

                .userInfo {
                    overflow: hidden;

                    .b {
                        display: block;
                        overflow: hidden;
                        width: 100%;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
}

#query-input-group2 {
    .supsis-button {
        &.ghost {
            height: 30px !important;
        }
    }
}
</style>
<style lang="scss" scoped>
.my-editor {
    background: #f7f7f7;
    color: #ccc;
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    padding: 5px;
    max-height: 300px;
    overflow: scroll;
}

.archiveUserInfoWidget {
    height: calc(100vh - 180px);
    overflow-y: auto;

    .rep-note-actions {
        display: flex;
        justify-content: end;
    }

    &::-webkit-scrollbar {
        display: none;
    }

    :last-child {
        margin-bottom: 0 !important;
    }

    .old-note {
        display: flex;
        align-items: center;
        font-size: 14px;
        cursor: pointer;
    }

    .old-note-desc {
        padding: 5px 10px;
        border: 0.5px solid #ffa800;
        margin-top: 5px;
        border-radius: 4px;

        .top-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .agent-name {
            font-size: 14px;
            font-weight: bold;
            color: #ffa800;
        }

        .old-note-date {
            font-size: 12px;
            font-weight: normal;
            color: #ffa800;
        }

        .agent-note {
            font-size: 12px;
        }
    }

    #chatCard {
        z-index: 9;
        padding: 15px 15px;
        margin-bottom: 10px;
        border-radius: 6px;
        overflow: hidden;
        border: 1px solid var(--color-border-default);

        .headtitle {
            margin-bottom: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .text {
                font-size: 16px;
                font-weight: 600;
                font-family: Poppins;
            }
        }

        .classic-button {
            border: none;
            background-color: #ffa80040;
            color: #ffa800;
            font-family: Poppins;
            font-weight: 600 !important;
            font-size: 14px;
            cursor: pointer;
            padding: 3px 10px;
            border-radius: 6px;
            display: flex;
            justify-content: center;
            align-items: center;

            &.visitor-attr {
                font-size: 12px !important;
                padding: 1px 10px !important;
                font-weight: 400 !important;
            }

            &.open-note {
                padding: 3px !important;
                margin-right: 5px;

                span.material-icons {
                    font-size: 16px !important;
                }
            }
        }

        .details-chat-card {
            &:first-child {
                margin-top: 0px !important;
            }

            .user-detail {
                display: flex;
                align-items: center;
                margin-top: 5px;

                .input-value {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    overflow: hidden;

                    .disableShortcut {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                    }

                    .edited-input {
                        display: flex;
                        justify-content: start;
                        align-items: center;
                        width: 80%;
                        margin-right: 5px;
                    }

                    .w-full {
                        text-overflow: ellipsis;
                        overflow: hidden;
                        width: 75%;
                        white-space: nowrap;
                    }
                }

                .copyButton {
                    border: transparent;
                    background: transparent;
                    color: green;
                }

                .icon {
                    margin-right: 8px;
                    color: #ffa800;
                    cursor: text;
                }
            }
        }
    }
}

.btn-start-chat {
    display: grid;
    gap: 5px;
}
</style>
<style lang="scss" scoped>
.spinner {
    color: #3699ff;
}

.actions {
    user-select: none;
    display: flex;
    align-items: center;
}

.display-flex {
    display: flex;
}

.ant-btn-background-ghost {
    background: transparent;
    border-color: transparent;
    color: gray;
}

.dark-mode .ant-btn-background-ghost {
    color: #fff;
    background: transparent;
    border-color: transparent;
}
</style>
<style lang="scss">
.multiselect__content-wrapper {
    min-height: 200px;
}

.multiselect__tag {
    padding: 1px 21px 5px 4px;
}

.multiselect__select {
    padding: 1px 13px 0px 0px;
    height: 24px;
    width: 8px;
}

.multiselect__tags {
    min-height: 30px !important;
    display: block;
    padding: 1px 25px 0px 7px !important;
    border-radius: 5px;
    border: 1px solid #e8e8e8;
    background: #fff;
    font-size: 14px;
}

.multiselect__tags-wrap {
    display: inline-flex;
}

.multiselect__placeholder {
    margin: 0;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
}

.archive-skeleton {
    .ant-skeleton-content .ant-skeleton-title {
        width: 39%;
        height: 16px;
        margin-top: 5px;
    }

    .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {
        margin-top: -5px;
        width: 65%;
    }

    .ant-skeleton-content .ant-skeleton-paragraph > li {
        width: 11%;
    }
}

#message-skeleton {
    .ant-skeleton {
        display: table;
        width: 69%;
        margin: 15%;
    }

    .ant-skeleton-content .ant-skeleton-paragraph > li {
        width: 100% !important;
    }

    .ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-title,
    .ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-paragraph > li {
        width: 100% !important;
    }
}

.new-theme {
    $row-height: 80px;

    .custom-checkbox3 {
        border: none;
        background-color: #f3f6f9;
        padding: 3px 10px;
        border-radius: 6px;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        font-family: Poppins;
        font-weight: 400;
        color: #1e1e2d;
        margin-left: 6px;
    }

    .userMetaInfo {
        position: absolute;
        top: 0;
        width: 100%;
        box-shadow: 0 0 3px #00000080;
        z-index: 9;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        transition: all 0.3s;
        transform: translateY(calc(-100% + 40px));

        &:hover {
            top: 0;
            transform: translateY(0);

            .md-icon.text-info {
                transition: all 0.3s;
                transform: rotateZ(180deg);
            }
        }
    }

    .info {
        .custom-card {
            display: flex;
            flex-direction: column;
            text-align: start;
            padding: 10px 20px;
            color: #181c32 !important;

            b {
                color: #181c32 !important;
            }
        }

        span {
            font-family: Poppins;
            font-weight: 300;
            color: #181c32;
            font-size: 12px;
            margin-bottom: 0;
            width: 90px;
            display: block;
        }

        b,
        b span {
            display: block;
            font-family: Poppins;
            font-weight: 500;
            color: #181c32;
            font-size: 12px;
            white-space: nowrap;
        }
    }

    .info {
        position: relative;
        height: $row-height;
        transition: all 0.3s;
        cursor: pointer;
        display: flex;

        .custom-card {
            width: 100%;
            height: 100%;
            border-radius: 0;
            color: #181c32 !important;

            b {
                color: #181c32 !important;
            }
        }

        .back {
        }
    }

    .user-info-container {
        .user-info {
            white-space: nowrap;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            max-width: 300px;
            -webkit-box-orient: vertical;
            margin-top: 20px;
            position: relative;

            .header {
                font-size: 16px;
                font-weight: 500;
                color: #3699ff;
                margin-bottom: 3px;
                display: flex;
                justify-content: space-between;

                .rep-note-name {
                    color: #b5b5b8;
                }
            }

            .content {
                display: flex;
                align-items: center;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                .icon-container {
                    margin-right: 5px;
                }

                &.text-area {
                    .rep-note-element {
                        width: 100%;

                        textarea {
                            min-width: 90% !important;
                        }
                    }
                }
            }

            :before {
                content: "";
                width: 100%;
                height: 1px;
                background-color: #eef0f8;
                bottom: -5px;
                left: 0;
                position: absolute;
                opacity: 0.8;
            }
        }

        &.dark {
            .user-info {
                .content {
                    color: white;
                }
            }
        }
    }

    .b-table {
        border-radius: 6px;
        box-shadow: none;
        margin-bottom: 0;

        thead {
            display: none;
        }

        tr {
            box-shadow: none !important;
            height: $row-height !important;
            padding: 0 !important;
            border-bottom: 1px solid #ebedf3;

            &.table-active {
                background-color: rgb(0 0 0 / 8%) !important;

                b,
                span {
                    color: #eef0f8;
                }
            }
        }

        td {
            padding: 0 !important;
            vertical-align: top !important;
            overflow: hidden;
        }
    }

    .row.custom-row {
        margin: 0 15px;

        div[class^="col"] {
            padding: 0;
        }
    }

    .scrollable {
        position: relative;
        overflow-y: scroll;
        scroll-behavior: smooth;
        scroll-padding-top: 10px;
        scroll-snap-type: y mandatory;
        scroll-snap-align: start;
        height: calc(100vh - 180px);
        min-height: 70vh;
        border-radius: 8px;
        border: 1px solid var(--color-border-default);
    }

    .custom-input input {
        background-color: #ffffff;
        border-radius: 6px !important;
        height: 30px;
    }

    .custom-input ul,
    .custom-input select {
        background-color: #ffffff;
        border: 1px solid var(--color-border-default);
        border-radius: 6px !important;
        height: 30px;
    }

    .custom-input ul {
        padding: 4px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #information-list2 {
        box-shadow: 0 0 3px #00000080;
        z-index: 9;
        background-color: #ffffff;
        padding: 20px;
        margin-bottom: 0px;
        border-radius: 6px;
        overflow-y: auto;
    }

    .head-title {
        font-size: 18px;
        color: #101217;

        &.dark {
            color: white;
        }
    }

    .userProfile {
        border: none;
        background-color: #fff4de;
        color: #ffa800;
        font-family: Poppins;
        font-weight: bolder;
        font-size: 14px;
        cursor: pointer;
        padding: 3px 10px;
        border-radius: 6px;
    }
}

#archive {
    width: calc(100vw - 60px);
    overflow: hidden;

    .archive-platform-multiselect {
        .option-icons {
            height: 18px;
            width: 18px;
            margin-right: 7px !important;
        }

        .multiselect__option--selected .multiselect__option--highlight[data-deselect="Selected"] {
            background: black !important;
            color: red !important;
        }
    }

    .archive-filter-icons {
        width: 22px !important;
        height: 22px !important;
    }

    .gallery-message {
        max-width: 600px;
    }

    .custom-breadcrumb {
        .text-dark {
            svg.archive-cb-icons {
                margin-top: 4px !important;

                g {
                    fill: black;
                }
            }

            svg.archive-insta-icons {
                margin-top: 4px !important;

                path {
                    fill: black !important;
                }
            }
        }

        .text-light {
            svg.archive-cb-icons {
                margin-top: 4px !important;

                g {
                    fill: white;
                }
            }

            svg.archive-insta-icons {
                margin-top: 4px !important;

                path {
                    fill: white !important;
                }
            }
        }
    }

    #archive-load-more-btn {
        position: absolute;
        bottom: 24px;
        right: 36%;
        opacity: 0.9;
    }

    .filterLabelWrapper {
        display: flex;
        justify-content: flex-end;
        padding: 6px;
        padding-right: 20px;
    }
}

.pagination-toolbar {
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 5px;
    justify-content: flex-end;

    .btnPerPage {
        display: flex;
        align-items: center;
        gap: 3px;

        svg {
            fill: var(--color-text-default);

            path {
                fill: var(--color-text-default);
            }
        }

        &:hover {
            svg {
                fill: var(--color-text-primary-default);

                path {
                    fill: var(--color-text-primary-default);
                }
            }
        }
    }
}

#start-date-input-group {
    .vdatetime-overlay {
        z-index: 1000 !important;
    }
}

#end-date-input-group {
    .vdatetime-overlay {
        z-index: 1000 !important;
    }
}

.btnPerPagePopover {
    .ant-popover-inner-content {
        padding: 0;
    }

    .page-options {
        display: flex;
        flex-direction: column;
        align-items: center;

        .item {
            min-width: 150px;
            cursor: pointer;
            padding: 10px;

            .value {
                padding: 10px;
            }

            &:hover {
                background: var(--color-bg-hover);
            }
        }
    }
}

.archive-toolbar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 20px;
    background-color: var(--color-bg-neutral-default);
    border-bottom: 1px solid var(--color-border-default);
    min-height: 50px;
    gap: 20px;

    .search-section {
        display: flex;
        align-items: center;
        gap: 15px;

        .search-bar {
            position: relative;
            width: 350px;
            max-width: 400px;
            flex: 1;

            &::before {
                content: '';
                position: absolute;
                left: 14px;
                top: 50%;
                transform: translateY(-50%);
                width: 16px;
                height: 16px;
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23999' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='8'%3E%3C/circle%3E%3Cpath d='m21 21-4.35-4.35'%3E%3C/path%3E%3C/svg%3E");
                background-repeat: no-repeat;
                background-position: center;
                z-index: 1;
                pointer-events: none;
            }

            .search-input {
                width: 100%;
                padding: 11px 45px 11px 45px;
                border: 1px solid #e8e8e8;
                border-radius: 25px;
                font-size: 14px;
                font-family: 'Poppins', sans-serif;
                background-color: #ffffff;
                transition: all 0.3s ease;
                
                &::placeholder {
                    color: #999;
                    font-weight: 400;
                }
                
                &:focus {
                    outline: none;
                    border-color: #3699ff;
                    box-shadow: 0 0 0 3px rgba(54, 153, 255, 0.08);
                    
                    &::placeholder {
                        color: #ccc;
                    }
                }

                &:hover {
                    border-color: #d0d0d0;
                }
            }

            .exclamation {
                position: absolute;
                right: 14px;
                top: 50%;
                transform: translateY(-50%);
                width: 18px;
                height: 18px;
                background-color: #ffd700;
                color: #333;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                font-size: 12px;
                cursor: help;
                box-shadow: 0 1px 3px rgba(255, 215, 0, 0.4);
                transition: all 0.3s ease;
                z-index: 2;

                &:hover {
                    background-color: #ffed4e;
                    transform: translateY(-50%) scale(1.05);
                    box-shadow: 0 2px 5px rgba(255, 215, 0, 0.5);
                }
            }
        }
    }
}

#time-select {
    border: none;
    background-color: #f3f6f9;
    padding: 3px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-family: Poppins;
    font-weight: bolder;
    color: #3699ff;
}
</style>
